<template>
  <div>
    <h2 class="step-name">Calf Health</h2>

    <div class="step-section">
      <h3> % cows wintered that were Rotavirus vaccinated </h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Season</th>
            <th>Cows Vaccinated</th>
            <th>Total Cows Wintered</th>
            <th>Percent Total Cows Wintered</th>
            <th>Region Avg. Percent Total Cows Wintered</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rv, index) in model.CHARTS.roto_vaccinations" :key="index"
            :class="getRowClass(model.CHARTS.roto_vaccinations, 'Season', index)">

            <td class="text-left">{{ rv["Season"] }}</td>
            <td class="text-left">{{ rv["Cows Vaccinated"] }}</td>
            <td class="text-left">{{ rv["Total Cows Wintered"] }}</td>
            <td class="text-left">{{ rv["Percent Total Cows Wintered"] }}</td>
            <td class="text-left">{{ rv["Region Avg. Percent Total Cows Wintered"] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-section">
      <h3> Seasonal Calf health products purchased </h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Season</th>
            <th>Product </th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(sp, index) in model.CHARTS.scour_products" :key="index"
            :class="getRowClass(model.CHARTS.scour_products, 'Season', index)">

            <td class="text-left">{{ sp["Season"] }}</td>
            <td class="text-left">{{ sp["Product"] }}</td>
            <td class="text-left">{{ sp["Quantity"] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-section">
      <h3>Seasonal Calf disbud purchases </h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Season</th>
            <th>Product/Service</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(dp, index) in model.CHARTS.disbud_products" :key="index"
            :class="getRowClass(model.CHARTS.disbud_products, 'Season', index)">

            <td class="text-left">{{ dp["Season"] }}</td>
            <td class="text-left">{{ dp["Product/Service"] }}</td>
            <td class="text-left">{{ dp["Quantity"] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="step-section">
      <div class="form-group">
        <label for="calf_health_keypoints">Key Points</label>
        <textarea rows="5" cols="50" v-model="model.calf_health_keypoints" class="form-control" :disabled="isReadOnly">
        </textarea>
      </div>

      <div class="form-group">
        <label for="calf_health_actions">Actions</label>
        <textarea rows="5" cols="50" v-model="model.calf_health_actions" class="form-control" :disabled="isReadOnly">
        </textarea>
      </div>
    </div>

  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component'

export default {
  mixins: [ baseComponent ],
  data() {
    return {
      model: {
        calf_health_keypoints: "",
        calf_health_actions: "",
        CHARTS: {
          disbud_products: [],
          roto_vaccination: [],
          scour_products: [],
        },
      },
    }
  },
  computed: {
  },
};
</script>
